import { Component } from '@angular/core';
import { BaseBPWizardFormComponent } from '../base-bp-wizard-form.component';
import { StateService, TransitionService } from '@uirouter/angular';
import { BPWizardAction, BPWizardService } from '../bp-wizard.service';
import { BPProfilesService } from '../../bp-profiles.service';
import { BPProfilesDataService } from '../../bp-profiles-data.service';
import { GaValidateService } from '../../../../shared/formly/ga-validate.service';
import { BPProfilesTCDataService } from '../../advanced/tc/bp-profiles-tc-data.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../shared/formly/ga-formly.service';
import { FormattingService } from '../../../../shared/services/formatting.service';
import { GaWizardService } from '../../../../shared/wizard/ga-wizard.service';
import { GaWizard } from '../../../../shared/wizard/ga-wizard';
import { WIZARD_BP_WIZARD } from '../../../../shared/app-wizards';
import { util } from '../../../../shared/util';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { IUserData } from '../../../../shared/services/auth/auth-data.service';

@Component({
  selector: 'bp-wizard-agreement',
  template: `
    <h2 [class.step-complete]="stepComplete"><text key="HEADING"></text></h2>
    <formly [form]="form" [model]="model" [fields]="fields"></formly>
  `
})
export class BPWizardAgreementComponent extends BaseBPWizardFormComponent {
  private wizard:GaWizard;

  constructor(
    private authService:AuthService,
    private wizardService:GaWizardService,
    private formattingService:FormattingService,
    private formlyService:GaFormlyService,
    transitionService:TransitionService,
    bpWizardService:BPWizardService,
    bpProfilesService:BPProfilesService,
    bpProfilesDataService:BPProfilesDataService,
    validateService:GaValidateService,
    stateService:StateService,
    bpProfilesTCDataService:BPProfilesTCDataService
  ) {
    super(transitionService, bpWizardService, bpProfilesService, bpProfilesDataService, validateService, stateService, bpProfilesTCDataService);
    this.wizard = this.wizardService.getInstance(WIZARD_BP_WIZARD);
  }

  protected createFields():IExtraFieldConfigurationObject[] {
    const fields:IExtraFieldConfigurationObject[] = [
      this.formlyService.aValue('resellerFee')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withFormat(this.formattingService.formatPct)
        .build(),
      this.formlyService.aValue('paymentTerms')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withFormat(this.formattingService.formatDays)
        .build(),
      this.formlyService.aValue('orderFees')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .build(),
      this.formlyService.aValue('memberPercentageOFFee')
        .withWrapperClass('triple-space-bottom')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withFormat(this.formattingService.formatPct)
        .build(),
      this.formlyService.aCheckbox('contractAgreed')
        .withoutWrapper()
        .onChange(this.onContractAgreedChanged)
        .build(),
      this.formlyService.aValue('contractAgreedBy', 'GA.GENERAL.NAME')
        .withoutEditable()
        .withWrapperClass('triple-space-top')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withFormat(this.formattingService.formatContact)
        .withHideExpression(() => {
          return !(this.model && this.model.contractAgreed);
        })
        .build(),
      this.formlyService.aValue('contractAgreedOn', 'GA.GENERAL.DATE')
        .withoutEditable()
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withFormat(this.formattingService.formatDate)
        .withHideExpression(() => !(this.model && this.model.contractAgreed))
        .build()
    ];
    this.wizard.setActionEnabled(BPWizardAction.SUBMIT, this.model && this.model.contractAgreed);
    return fields;
  }

  private onContractAgreedChanged = (value:boolean):void => {
    const currentUser:IUserData = this.authService.getCurrentUser();

    // set contractAgreedBy = current user and contractAgreedOn = today
    this.model.contractAgreedBy = this.model.contractAgreedBy || {
      id: currentUser.id,
      firstname: currentUser.firstname,
      lastname: currentUser.lastname
    };
    this.model.contractAgreedOn = this.model.contractAgreedOn || util.currentTimeMillis();

    this.wizard.setActionEnabled(BPWizardAction.SUBMIT, value);
  };
}